import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class ModuleParticipantsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'ModuleParticipantsStateModel';
    userIds: string[];
    moduleUserIds: string[];

    constructor() {
        super(ModuleParticipantsStateModel.identifier);
        this.userIds = [];
        this.moduleUserIds = [];
    }
}
